<template>
  <div class="bug_box">
    <div >
      <label :for="'boxitemidtrue'+index" class='bug_label' v-on:click="cdValue(1)">
          <input type="radio"  :disabled="DataConfirm?.length > 0" :value="1" v-model="item.isActive">
          <p>Согласен</p>
      </label>
      <label :for="'boxitemidfalse'+index" class='bug_label' v-on:click="cdValue(0)">
          <input type="radio"  :disabled="DataConfirm?.length > 0" :value="0" v-model="item.isActive">
          <p>Не согласен</p>
      </label>
    </div>
    <div>
      <h2>{{item.Print_Title}}</h2>
      <p>Описание услуги:</p>
      <p>{{item.Print_Info}}</p>
    </div>
    <div>
      <p>Стоимость услуги: {{item.Cost | moneyFormat}} руб. <a href="#" v-on:click="toggleDescription">{{showDescriptionTitle}}</a></p>
      <p v-show="showDescription">{{item.Print_Discription}}</p>
    </div>

  </div>
</template>

<script>

export default {
  name: 'agreementBoxesItem',
  props:{
    index:{
      type:Number,
      default() {
        return 0;
      }
    },
    item:{
      type: Object ,
      default(){
       return {
         isActive:0
       }
      }
    },
    DataConfirm:{
      type:String,
      default:''
    },
  },
  data(){
    return {
      boxValue:0,
      showDescription:false,
    }
  },
  methods:{
    toggleDescription($event){
      $event.preventDefault();
      this.showDescription = !this.showDescription
    },
    cdValue(value){
      console.log(this.key)
      this.$emit('cdValue',{
        index: this.index,
        value: value
      });
    }
  },
  computed:{
    showDescriptionTitle(){
      return this.showDescription ? 'Скрыть' : 'Подробнее';
    }
  }
};
</script>

<style>
.bug_box{display: flex;align-items: stretch;justify-content: space-between;border: 1px solid #c2c2c2;flex-wrap: wrap}
.bug_box > div{width: calc(100% - 8vw);padding: 4vw;}

.bug_box label{border: 1px solid transparent;border-radius: 9px;box-shadow: 0 4px 4px #00000040;transition: .3s ease-out;display: flex;align-items: center;justify-content: space-around;cursor: pointer;padding: 2vw;}
.bug_box label:hover{background: rgba(67, 172, 52, 0.25);border:1px solid #43AC34}
.bug_box label input{width: 10%;}
.bug_box label p{width: 80%;}


@media screen and (min-width: 760px) {
  .bug_box{}
  .bug_box > div{width: calc(49% - 4vw);padding: 2vw;}
  .bug_box > div:last-child{width: 100%;border-right: 0}
  .bug_box label{padding: 2vw;}
  .bug_box label input{width: 10%;}
  .bug_box label p{width: 80%;}
}
@media screen and (min-width: 1240px) {
  .bug_box{}
  .bug_box > div{padding: 20px;}
  .bug_box > div:nth-child(1){width:calc(30% - 40px)}
  .bug_box > div:nth-child(2){width:calc(70% - 40px)}
  .bug_box label{padding: 15px;}
  .bug_box label input{width: 10%;}
  .bug_box label p{width: 80%;}
}
</style>

